import HundredBricksAPIError from '../../HundredBricksAPIError';
class RegisterPhoneError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('RegisterPhoneError', ...args);
    }
}
export default RegisterPhoneError;
